<script setup>

</script>

<template>
  <div id="page-style">
    <div class="app-version top-version-text title error-title">Error 404</div>
    <div class="loginBox">
      <div class="inner">

        <div class="top">
          <img alt="Missing Page" src="../assets/sick computer.png" class="logo">
        </div>

        <div>
          <div class="signIn">
            <div class="title">Oops!</div>
            <div class="subtitle form-subtitle">
              This page does not exist.
              <span class="subtitle-action"> <a href="/"> Take me home</a> </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="app-version bottom-version-text">Surgical Access For Everyone</div>
  </div>
</template>

<style scoped>

.error-title{
  margin: 0 !important;
  font-weight: normal !important;
}
</style>